// extracted by mini-css-extract-plugin
var _1 = "EntityTabRequests-moduleEntityTabRequests__vjr55";
var _2 = "EntityTabRequests-modulecontent__KADEw";
var _3 = "EntityTabRequests-modulecontentEmpty__skqdK";
export { _1 as "EntityTabRequests", _2 as "content", _3 as "contentEmpty" }
